// Saca de la respuesta del servidor el primer mensaje que se pueda mostrar.
//
// Leer solo unas claves conocidas era el problema: cualquier error fuera de esa
// lista —o una pagina de error en HTML, que no es un objeto— caia en el texto
// generico, y el usuario quedaba sin saber que corregir. Acá se recorre lo que
// haya venido.
export function mensajeDeError(error, porOmision = 'No se pudo completar la operación.') {
    const datos = error?.response?.data;
    if (!datos) return porOmision;
    if (typeof datos === 'string') {
        // Una página de error de Django llega como HTML: no hay nada legible
        // que mostrar, así que vale más el texto por omisión.
        return datos.trim().startsWith('<') ? porOmision : datos;
    }
    if (Array.isArray(datos)) return String(datos[0] ?? porOmision);
    for (const valor of Object.values(datos)) {
        if (Array.isArray(valor) && valor.length) return String(valor[0]);
        if (typeof valor === 'string' && valor) return valor;
    }
    return porOmision;
}
